module.exports = __webpack_public_path__ + "static/media/gallery05.5e674811.gif";